// @ts-strict-ignore
import type { ReactNode } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown, DropdownContent, DropdownItem, DropdownSearch, Skeleton } from "@aviary";
import type { PractitionerType } from "@unauthenticated/shared/data/types/PractitionerType.d";
import { l } from "@unauthenticated/shared/locales/i18n";

import { useDesignations } from "../DesignationSearch/useDesignations";

interface Props {
  practitionerTypes: PractitionerType[];
  setValue: (value: string) => void;
  hideTooltip?: boolean;
  children: ReactNode;
}

const DesignationDropdown = ({ practitionerTypes, setValue, children }: Props) => {
  const [search, setSearch] = useState("");
  const { t } = useTranslation();
  const { designations } = useDesignations(practitionerTypes);

  const renderItem = (item: PractitionerType) => (
    <DropdownItem key={item.id} onSelect={() => setValue(item.id)}>
      {item.description}
    </DropdownItem>
  );

  const renderItems = () => {
    const items = [...designations]
      .filter(item => {
        if (search) {
          return item.description.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        }

        return true;
      })
      .map(renderItem);
    if (!items.length) {
      return <DropdownItem disabled>{t(l.common.NoResults)}</DropdownItem>;
    }

    return items;
  };

  if (!designations.length) {
    return <Skeleton type="button" buttonSize="small" isFullWidth />;
  }

  return (
    <Dropdown customDropdownHeight={11} isFullWidth data-e2e="practitioner-type">
      {children}
      <DropdownContent>
        <DropdownSearch
          placeholder={t(l.common.Search)}
          onChange={e => setSearch(e.target.value)}
          value={search}
          onCancel={() => setSearch("")}
        />
        {renderItems()}
      </DropdownContent>
    </Dropdown>
  );
};

export { DesignationDropdown };
